import { useCallback, useEffect } from 'react';
import useCanManage from './UseCanManage';
import { useNavigate } from 'react-router-dom';

const useRedirectWhenInvalidStatus = () => {
  const navigation = useNavigate();
  const { checkCanManage } = useCanManage();

  const refreshAccountAndCheckRedirect = useCallback(async () => {
    const canManage = await checkCanManage();
    if (!canManage) {
      navigation('/');
    }
  }, []);

  useEffect(() => {
    refreshAccountAndCheckRedirect();
  }, []);
};

export default useRedirectWhenInvalidStatus;
